// extracted by mini-css-extract-plugin
module.exports = {"content-recommendation-title":"ContentRecommendation_content-recommendation-title__MaOyX"};